import React from 'react';
import CommonSVGIcon, { Props } from '@/components/icons/CommonSVGIcon';

export default function Circle(props: Props) {
  return (
    <CommonSVGIcon {...props} viewBox="0 0 10 10">
      <rect x="0.5" y="0.5" width="9" height="9" rx="4.5"/>
    </CommonSVGIcon>
  );
}
